<template>
  <div class="alarm">
      <v-layout row wrap>
          <v-flex>
            <v-flex text-xs-left pl-3>
				<p>Buscar</p>
			</v-flex>
            <v-flex class="search pb-3">
                <input type="text"
				placeholder="Escriba su nombre o apellido / empresa">
                <v-btn class="search-btn">Buscar</v-btn>
            </v-flex>
			<div class="divider"></div>
          </v-flex>
      </v-layout>
	  <v-layout row wrap>
		  <v-flex text-xs-left md6 mr-5 xs12>
			  <p>Completa los datos</p>
			  <p>Huésped</p>
			  <p class="name">Ariel Esteban Puga Ogalde</p>
			  <div class="check-info">
				   <div class="check-in">
						<label for="">Check in</label>
						<input type="text">
					</div>
					<div class="check-out">
						<label for="">Check out</label>
						<input type="text">
					</div>
			  </div>
			  <div class="observation pl-2 mt-5">
				  <p>Observacióon</p>
				  <textarea name="" id="" cols="30" rows="10"
				  placeholder="Escribe alguna observación"></textarea>
				  <v-btn class="observation-button">Guardar</v-btn>
			  </div>
		  </v-flex>
		   <v-flex row wrap md5 xs12 pt-5>
			  <div class="time-picker">
				  <div class="alarm-time">
					  <span class="pr-3">Hora de la llamada</span>
					  <button class="btn-timer">a.m.</button>
					  <button class="btn-timer">p.m.</button>
				  </div>
				  <div class="watch"></div>
				  <div class="time"><span>1:13 A.M.</span> </div>
			  </div>
		  </v-flex>
	  </v-layout>
	  
  </div>
</template>

<script>
export default {
	name: 'list',
};
</script>

<style lang="scss" scoped>
.alarm{
	.search{
		display: flex;
		.search-btn{
			background-color: map-get($colors, default-skyblue) !important;
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
			color: map-get($colors, white-bond);
			height: 38px;
			width: 109px;
		}
		input{
			background-color: white;
			box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);
			color:  map-get($colors, default-button-color);
			height: 40px;
			margin-right: 11.8px;
			padding: 0px 5px;
			width: 100%;
		}
	}
	.name{
		color: map-get($colors, dark );
		font-size: 20px;
		font-stretch: normal;
		font-style: normal;
		font-weight: 600;
		height: 24px;
		letter-spacing: normal;
		line-height: normal;
		text-align: left;
		width: 231px;
	}
	.check-info{
		display: flex;
		.check-in, .check-out{
			display: grid;
			height: 40px;
			margin-right: 28px;
			padding: 5px;
			width: 231px;
			input{
				background-color: white;
				box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
				color: map-get($colors, default-button-color);
				height: 40px;
				padding: 0px 5px;
				width: 231px;
			}
		}
	}
	.observation{
		textarea{
			background-color: white;
			box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);
			color: map-get($colors, default-button-color);
			height: 195.1px;
			padding: 5px;
			width: 492px;
		}
		.observation-button{
			background: map-get($colors, default-skyblue);
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
			color: white;
			display: block;			
			height: 38px;
			margin-left: 5px;
			margin-top: 24px;
			width: 164px;
		}
		
	}
}
.time-picker{
	border-left: 1px solid map-get($colors, border-radio);
	.alarm-time{
		.btn-timer{
			background-color: map-get($colors, default-bg);
			border: 1px solid map-get($colors, grey-text);
			border-radius: 100px;
			font-stretch: normal;
			font-style: normal;
			font-weight: 600;
			height: 23px;
			letter-spacing: normal;
			line-height: normal;
			text-align: center;
			width: 45px;
		}
		.btn-timer:focus{
			background-color: map-get($colors, default-skyblue );
			border-radius: 100px;
			box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.24);
			color: map-get($colors, default-bg);
			height: 23px;
			font-size: 14px;
			font-stretch: normal;
			font-style: normal;
			font-weight: 600;
			letter-spacing: normal;
			line-height: normal;
			text-align: center;
			width: 45px;
		}
	}
	.watch{
		height: 240px;
		width: 240px;
	}
	.time{
		background: white;
		border-radius: 35px;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		font-size: 40px;
		font-stretch: normal;
		font-style: normal;
		font-weight: bold;
		height: 63.7px;
		letter-spacing: normal;
		line-height: 63.7px;
		margin: auto;
		text-align: center;
		width: 182.8px;
	}
}
</style>




// WEBPACK FOOTER //
// List.vue?1b00eca3